import { Colors, Services } from '@sigma-frontend-libs/commons'

import { getLocaleDateString, getLocaleTimeString, icons } from '@/utils'

import actions from '@/components/services/sendingsModeration/actions'
import sticker from '@/components/sticker'

function renderRecipientsCount(h) {
  return h(
    sticker,
    {
      props: {
        value: [ this.value.total, this.value.segments ].join(' / '),
        label: this.getTranslate(`${Services.sendingsModeration}.labels.recipientsCount`)
      }
    }
  )
}

function renderSender(h) {
  if (this.viewport.breakpoint.smUp) {
    return h(
      sticker,
      {
        props: {
          value: this.value.sender,
          label: this.getTranslate(`${Services.sendingsModeration}.labels.sender`),
          copy: true
        }
      }
    )
  }
}

function renderText(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.text,
        label: this.getTranslate(`${Services.sendingsModeration}.labels.text`),
        copy: true
      }
    }
  )
}

function renderOperator(h) {
  if (this.viewport.breakpoint.mdUp && this.hasOperator) {
    return h(
      sticker,
      {
        props: {
          value: this.value.operator,
          label: this.getTranslate(`${Services.sendingsModeration}.labels.operator`)
        }
      }
    )
  }
}

function renderActions(h) {
  return h(
    actions,
    {
      props: {
        sending: this.value,
        filter: this.filter,
        range: this.range
      }
    }
  )
}

function renderDates(h) {
  if (this.viewport.breakpoint.xl) {
    return Object.keys(this.value.createdAt).map(date => {
      return h(
        sticker,
        {
          props: {
            value: getLocaleTimeString(this.value.createdAt[date]),
            label: getLocaleDateString(this.value.createdAt[date]),
            icon: icons.date_range,
            color: Colors.grey,
            minWidth: 140,
            width: 140,
            iconTooltip: this.getTranslate(`${Services.sendingsModeration}.tooltips.createdAt.${date}`),
            copy: true,
            button: {
              iconSVG: 'copy',
              color: Colors.grey,
              tooltip: this.getTranslate('misc.buttons.copy'),
              callback: () => {
                navigator.clipboard.writeText([ getLocaleDateString(this.value.createdAt[date]), getLocaleTimeString(this.value.createdAt[date]) ].join(' '))
              }
            }
          }
        }
      )
    })
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item': true,
        [`${Services.sendingsModeration}-sending hover-parent hover-parent--opacity`]: true
      },
      style: { gridTemplateColumns: this.gridTemplateColumns }
    },
    [
      renderRecipientsCount.call(this, h),
      renderSender.call(this, h),
      renderText.call(this, h),
      renderOperator.call(this, h),
      renderActions.call(this, h),
      renderDates.call(this, h)
    ]
  )
}
